import type { ComponentPropsWithoutRef } from "react";
import type { Control } from "react-hook-form";
import { t } from "ttag";

import { Form, Select } from "@/shared/ui";
import { useCoachOptions } from "../hooks";
import type { AdminSession } from "../models";

type FieldValue = Pick<AdminSession, "coachId">;

type SessionCoachControl<T> = T extends FieldValue ? Control<T> : never;

type SessionCoachFieldProps<T extends FieldValue> = ComponentPropsWithoutRef<
  typeof Form.Item
> & {
  control: SessionCoachControl<T>;
};

export const SessionCoachField = <T extends FieldValue>({
  control,
  ...props
}: SessionCoachFieldProps<T>) => {
  const { data: coachOptions, isLoading } = useCoachOptions();

  return (
    <Form.Field
      control={control}
      name="coachId"
      render={({ field: { value, ...field } }) => (
        <Form.Item {...props}>
          <Form.Label aria-required>{t`Coach`}</Form.Label>
          <Form.Control>
            <Select
              options={coachOptions}
              isLoading={isLoading}
              value={value ?? ""}
              {...field}
            />
          </Form.Control>
          <Form.Message compact={false} />
        </Form.Item>
      )}
    />
  );
};
